// Display helpers for the crypto holdings.

/**
 * A price, with as many decimals as it needs to say something.
 *
 * Two fixed decimals, as every other price on these pages uses, turns a
 * $0.00001234 token into "$0.00" — a price, formatted, that reads as "free".
 * Above $1 it is two decimals like the rest; below, four significant digits.
 */
export function formatPrice(value, intl) {
    if (value === null || value === undefined || !Number.isFinite(value)) return null;
    if (Math.abs(value) >= 1) {
        return value.toLocaleString(intl, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return value.toLocaleString(intl, { maximumSignificantDigits: 4 });
}

/** A token quantity: up to six decimals, fewer as the amount grows. */
export function formatQuantity(value, intl) {
    if (value === null || value === undefined || !Number.isFinite(value)) return null;
    const decimals = Math.abs(value) >= 1000 ? 2 : Math.abs(value) >= 1 ? 4 : 6;
    return value.toLocaleString(intl, { maximumFractionDigits: decimals });
}

const DAY = 86_400_000;

/**
 * How long a position has been held, as the parts a label needs.
 *
 * Calendar months, not 30-day blocks: bought 31 January, held on 1 March is one
 * month, which is what a reader counting on their fingers expects.
 */
export function heldFor(sinceIso, now = new Date()) {
    if (!sinceIso) return null;
    const since = new Date(sinceIso);
    if (Number.isNaN(since.getTime())) return null;
    const days = Math.floor((now - since) / DAY);
    if (days < 0) return null;
    if (days < 60) return { days };

    let months = (now.getFullYear() - since.getFullYear()) * 12 + (now.getMonth() - since.getMonth());
    if (now.getDate() < since.getDate()) months -= 1;
    return { years: Math.floor(months / 12), months: months % 12 };
}

/** Enough of an address to recognise, not enough to mistake for the whole. */
export const shortAddress = (address) =>
    !address || address.length <= 12 ? address : `${address.slice(0, 6)}…${address.slice(-4)}`;
